import apiClient from './client';

export const botsApi = {
  getAll: (params) => apiClient.get('/api/bots', { params }),

  getById: (id) => apiClient.get(`/api/bots/${id}`),

  create: (data) => apiClient.post('/api/bots', data),

  update: (id, data) => apiClient.put(`/api/bots/${id}`, data),

  delete: (id) => apiClient.delete(`/api/bots/${id}`),

  getWaFlow: (id) => apiClient.get(`/api/bots/${id}/wa-flow`),

  getWaBlocks: (id) => apiClient.get(`/api/bots/${id}/wa-blocks`),

  createWaBlock: (id, data) => apiClient.post(`/api/bots/${id}/wa-blocks`, data),

  getWaBlockById: (blockId) => apiClient.get(`/api/wa-blocks/${blockId}`),

  updateWaBlock: (blockId, data) => apiClient.put(`/api/wa-blocks/${blockId}`, data),

  deleteWaBlock: (blockId) => apiClient.delete(`/api/wa-blocks/${blockId}`),

  getWaMessages: (blockId) => apiClient.get(`/api/wa-blocks/${blockId}/messages`),

  createWaMessage: (blockId, data) => apiClient.post(`/api/wa-blocks/${blockId}/messages`, data),

  updateWaMessage: (messageId, data) => apiClient.put(`/api/wa-messages/${messageId}`, data),

  deleteWaMessage: (messageId) => apiClient.delete(`/api/wa-messages/${messageId}`),

  getWaConnections: (id) => apiClient.get(`/api/bots/${id}/wa-connections`),

  createWaConnection: (id, data) => apiClient.post(`/api/bots/${id}/wa-connections`, data),

  updateWaConnection: (connectionId, data) =>
    apiClient.put(`/api/wa-connections/${connectionId}`, data),

  deleteWaConnection: (connectionId) => apiClient.delete(`/api/wa-connections/${connectionId}`),

  cleanupWaConnections: (id) => apiClient.post(`/api/bots/${id}/wa-connections/cleanup`),

  getActive: () => apiClient.get('/api/bots/active'),
};

export default botsApi;
